import React from "react";

class OutsideClickHandlerHOC extends React.Component {
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = event => {
    const wrapper = document.querySelector(
      `.${this.props.name}${this.props.index}`
    );

    if (
      !wrapper.contains(event.target) &&
      this.props.isOpened &&
      this.props.calculatorIndex
    ) {
      this.props.onOutsideClick();
    }
  };

  render() {
    return (
      <div className={`${this.props.name}${this.props.index}`}>
          {this.props.children}
      </div>
    );
  }
}

export default OutsideClickHandlerHOC;
